import Callout from "ds/components/Callout";
import DeploymentProgressCallout from "components/DeploymentProgressCallout";
import { TemplateDeploymentState } from "types/generated";

type DeploymentStateCalloutProps = {
  state: TemplateDeploymentState;
};

const DeploymentStateCallout = ({ state }: DeploymentStateCalloutProps) => {
  switch (state) {
    case TemplateDeploymentState.InProgress:
    case TemplateDeploymentState.None:
      return <DeploymentProgressCallout />;
    case TemplateDeploymentState.Failure:
      return (
        <Callout variant="danger" title="Deployment failed">
          Something went wrong while setting up your deployment. Please contact the template creator
          for assistance.
        </Callout>
      );
    case TemplateDeploymentState.DestroyingFailed:
      return (
        <Callout variant="danger" title="Deletion failed">
          Something went wrong while deleting your deployment. Please contact the template creator
          for assistance.
        </Callout>
      );
    case TemplateDeploymentState.Unconfirmed:
      return (
        <Callout variant="warning" title="Awaiting confirmation">
          Your deployment is pending review. The template creator needs to confirm it before
          provisioning can begin.
        </Callout>
      );
    case TemplateDeploymentState.Destroying:
    case TemplateDeploymentState.Discarded:
    case TemplateDeploymentState.Finished:
      return null;
  }
};

export default DeploymentStateCallout;
